export default {
    staffData: {items: [], _links: {}, _meta: {}},
    staffList: [],
    workingHours: {},
    serviceList: [],
    serviceData: {items: [], _links: {}, _meta: {}},
    staffServiceList: [],
    staffServiceData: {items: [], _links: {}, _meta: {}},
    checkinStaff: null,
    // themeColors: ['#7367F0', '#2979FF', '#E2A6E5', '#FF9F43', '#28C76F', '#A0522D', '#1E1E1E', '#94AAD6', '#E2A6E6',
    //             '#BBC1E8', '#A5DFF8', '#FFB5C5', '#FBB917', '#A6E5BD', '#C0C0C0', '#696969']
    // themeColors: ['#9E4CEF','#7D91E8', '#7366F0', '#67ADFF', '#5B94E2', '#64CBE3', '#83B5B9', '#92C961', '#FBBA17',
    //             '#DB64CD','#F26E6E', '#E8A2BB', '#F06696', '#E55555', '#D8683E', '#FF9188', '#FA914B',  '#FCB88D'],
    //             // , '#B0E0E6', '#FF9CBB']
    // themeColors: ['#F98B8E','#FCB88D', '#82CCB5', '#71ABDD', '#8F9BCE', '#C5A896', '#F79D8B', '#FDCD79', '#81D2A2', '#6BCADE',
    //               '#A19CCB','#CCA7AA', '#DF93A8', '#F4B97C', '#B6D884', '#8BD4D2', '#C083A9', '#E6C3A8',  '#E89B68', '#FFA468',
    //               '#C4C487','#83B5B9', '#CCA7CD', '#BBB4AC', '#ED6D79', '#D9A429', '#A2AE66', '#66A7AC',  '#88729D', '#B38888'],
    // themeColorsCate: ['#F98B8E','#FCB88D', '#82CCB5', '#71ABDD', '#8F9BCE', '#C5A896', '#F79D8B', '#FDCD79', '#81D2A2', '#6BCADE',
    //               '#A19CCB','#CCA7AA', '#DF93A8', '#F4B97C', '#B6D884', '#8BD4D2', '#C083A9', '#E6C3A8',  '#E89B68', '#FFA468',
    //               '#C4C487','#83B5B9', '#CCA7CD', '#BBB4AC', '#ED6D79', '#D9A429', '#A2AE66', '#66A7AC',  '#88729D', '#B38888'],
    themeColors: ['#EA5C2B', '#2DC069', '#4659BD', '#C85CE0', '#74B42B', '#F38702', '#596FF6', '#F655BD', '#07B4A4', '#B55812', 
                  '#217AA3', '#FF8E77', '#9D67D0', '#4BAF28', '#CC9F02', '#035397', '#FF7175', '#6E3CBC', '#00A3FF', '#F1A815',
                  '#DCC0E0', '#FCB88D', '#82CCB5', '#71ABDD', '#8F9BCE', '#C5A896', '#F79D8B', '#FDCD79', '#81D2A2', '#6BCADE',
                  '#A19CCB','#CCA7AA', '#DF93A8', '#F4B97C', '#B6D884', '#8BD4D2', '#C083A9', '#E6C3A8',  '#E89B68', '#FFA468',
                  '#C4C487','#83B5B9', '#CCA7CD', '#BBB4AC', '#942CA6', '#D9A429', '#A2AE66', '#66A7AC',  '#88729D', '#B38888', '#BC5ECC', '#DC8EEA'],
    themeColorsCate: ['#EA5C2B', '#2DC069', '#4659BD', '#C85CE0', '#74B42B', '#F38702', '#596FF6', '#F655BD', '#07B4A4', '#B55812', 
                  '#217AA3', '#FF8E77', '#9D67D0', '#4BAF28', '#CC9F02', '#035397', '#FF7175', '#6E3CBC', '#00A3FF', '#F1A815',
                  '#DCC0E0', '#FCB88D', '#82CCB5', '#71ABDD', '#8F9BCE', '#C5A896', '#F79D8B', '#FDCD79', '#81D2A2', '#6BCADE',
                  '#A19CCB','#CCA7AA', '#DF93A8', '#F4B97C', '#B6D884', '#8BD4D2', '#C083A9', '#E6C3A8',  '#E89B68', '#FFA468',
                  '#C4C487','#83B5B9', '#CCA7CD', '#BBB4AC', '#942CA6', '#D9A429', '#A2AE66', '#66A7AC',  '#88729D', '#B38888', '#BC5ECC', '#DC8EEA'],

    themeNewColors: ['#F15620', '#12BC58', '#4057D1', '#F1A815', '#EB4472', '#00A4FF', '#4BAF28', '#FD7319', '#09A576', '#FC4184', '#0076E3',
                      '#BE3CDB', '#F38702', '#5138E8', '#61B600', '#229874', '#C35F20', '#F85CB9', '#5F18D3', '#07B4A4', '#FF4A55', '#DD6610'],

    themeNewColorsCate: ['#F15620', '#12BC58', '#4057D1', '#F1A815', '#EB4472', '#00A4FF', '#4BAF28', '#FD7319', '#09A576', '#FC4184', '#0076E3',
                      '#BE3CDB', '#F38702', '#5138E8', '#61B600', '#229874', '#C35F20', '#F85CB9', '#5F18D3', '#07B4A4', '#FF4A55', '#DD6610'],

    themeColorsAppointment: ['#F98B8E','#FCB88D', '#82CCB5', '#71ABDD', '#8F9BCE', '#C5A896', '#F79D8B', '#FDCD79', '#81D2A2', '#6BCADE',
                  '#A19CCB','#CCA7AA', '#DF93A8', '#F4B97C', '#B6D884', '#8BD4D2', '#C083A9', '#E6C3A8',  '#E89B68', '#FFA468',
                  '#C4C487','#83B5B9', '#CCA7CD', '#BBB4AC', '#FF0000', '#D9A429', '#A2AE66', '#3a87ad',  '#88729D', '#B38888'],
    themeColorsAnyStaff: ['#F98B8E','#FCB88D', '#82CCB5', '#71ABDD', '#8F9BCE', '#C5A896', '#F79D8B', '#FDCD79', '#81D2A2', '#6BCADE',
                  '#A19CCB','#CCA7AA', '#DF93A8', '#F4B97C', '#B6D884', '#8BD4D2', '#C083A9', '#E6C3A8',  '#E89B68', '#FFA468',
                  '#C4C487','#83B5B9', '#CCA7CD', '#BBB4AC', '#ED6D79', '#D9A429', '#A2AE66', '#66A7AC',  '#88729D', '#FFFFFF'],
    commissionList: {},
    serviceCommission : [
      {id: 1, start: 70, end: 30, name: '70-30', type: 'service'},
      {id: 2, start: 60, end: 40, name: '60-40', type: 'service'},
      {id: 3, start: 50, end: 50, name: '50-50', type: 'service'},
      {id: 4, start: 40, end: 60, name: '40-60', type: 'service'},
      {id: 5, start: 0, end: 100, name: '0-100', type: 'service'},
      {id: 6, start: 0, end: -1, name: 'other', type: 'service'}
    ],
    productCommission: [
      {id: 1, start: 70, end: 30, name: '70-30', type: 'product'},
      {id: 2, start: 60, end: 40, name: '60-40', type: 'product'},
      {id: 3, start: 50, end: 50, name: '50-50', type: 'product'},
      {id: 4, start: 40, end: 60, name: '40-60', type: 'product'},
      {id: 5, start: 0, end: 100, name: '0-100', type: 'product'},
      {id: 6, start: 0, end: -1, name: 'other', type: 'product'}
    ],
    giftcardCommission: [
      {id: 1, start: 70, end: 30, name: '70-30', type: 'giftcard'},
      {id: 2, start: 60, end: 40, name: '60-40', type: 'giftcard'},
      {id: 3, start: 50, end: 50, name: '50-50', type: 'giftcard'},
      {id: 4, start: 40, end: 60, name: '40-60', type: 'giftcard'},
      {id: 5, start: 0, end: 100, name: '0-100', type: 'giftcard'},
      {id: 6, start: 0, end: -1, name: 'other', type: 'giftcard'}
    ],
    cashCheckPercentage: [
      {id: 1, start: 70, end: 30, name: '70-30', type: 'cashcheck'},
      {id: 2, start: 60, end: 40, name: '60-40', type: 'cashcheck'},
      {id: 3, start: 50, end: 50, name: '50-50', type: 'cashcheck'},
      {id: 4, start: 40, end: 60, name: '40-60', type: 'cashcheck'},
      {id: 5, start: 0, end: -1, name: 'other', type: 'cashcheck'}
    ],
    permissionList: []
}
